import { render, staticRenderFns } from "./anatomiaPanel.vue?vue&type=template&id=7baaf8f4&scoped=true"
import script from "./anatomiaPanel.vue?vue&type=script&lang=js"
export * from "./anatomiaPanel.vue?vue&type=script&lang=js"
import style0 from "./anatomiaPanel.vue?vue&type=style&index=0&id=7baaf8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baaf8f4",
  null
  
)

export default component.exports